export default {
  nav: {
    main: 'Κύριο',
    ordersAndInvoices: 'Παραγγελίες και Τιμολόγια',
    drafts: 'Προσχέδια',
    automation: 'Αυτοματισμός',
    workspace: 'Χώρος εργασίας',
    templates: 'Πρότυπα',
    delivery: 'Παράδοση',
    settings: 'Ρυθμίσεις',
    shippingLabels: 'Ετικέτες Αποστολής',
    subscriptions: 'Συνδρομές',
    support: 'Υποστήριξη',
    developer: 'Προγραμματιστής',
    writeReview: 'Γράψτε μια Κριτική',
    supportTicket: 'Αίτημα Υποστήριξης',
    welcomeTour: 'Περιήγηση Καλωσορίσματος',
    administratorConsole: 'Κονσόλα Διαχειριστή',
    logout: 'Αποσύνδεση',
  },
  dashboard: {
    pageTitle: 'Παραγγελίες και Τιμολόγια',
    pageDescription: 'Manage your orders and invoices',
    title: 'Παραγγελίες και Τιμολόγια',
    selectedOrders: '{count} επιλεγμένες παραγγελίες',
    completed: '% ολοκληρώθηκε',
    processing: 'Επεξεργασία, παρακαλώ περιμένετε...',
    bulkDownload: 'Μαζική Λήψη',
    upgradeBulkDownload: 'Αναβαθμίστε το πλάνο σας για Μαζική Λήψη',
    showFilters: 'Εμφάνιση Φίλτρων',
    hideFilters: 'Απόκρυψη Φίλτρων',
    creatingInvoices: 'Δημιουργία τιμολογίων, παρακαλώ περιμένετε...',
    bulkCreateInvoices: 'Μαζική Δημιουργία Τιμολογίων',
    cannotCreateAutopilot: 'Δεν μπορείτε να δημιουργήσετε τιμολόγια χειροκίνητα όταν η τιμολόγηση είναι σε αυτόματη λειτουργία.',
    exportInvoices: 'Εξαγωγή τιμολογίων ή παραγγελιών',
    capturePayments: 'Χειροκίνητη Καταγραφή Πληρωμών',
    filterOrders: 'Φιλτράρισμα παραγγελιών',
    error: 'Κάτι πήγε στραβά...',
    close: 'Κλείσιμο',
    chooseDate: 'Επιλέξτε ημερομηνία',
    chooseIssueDate: 'Επιλέξτε ημερομηνία έκδοσης για τα επιλεγμένα τιμολόγια',
    cancel: 'Ακύρωση',
    createInvoices: 'Δημιουργία Τιμολογίων',
    storno: 'Storno',
    bulkOrderCapture: 'Μαζική Καταγραφή Παραγγελιών',
  },
  search: {
    createdBetween: 'Δημιουργήθηκε μεταξύ',
    modifiedBetween: 'Τροποποιήθηκε μεταξύ',
    orderNumber: 'Παραγγελία #',
    invoiceNumber: 'Τιμολόγιο #',
    refundNumber: 'Επιστροφή #',
    customer: 'Πελάτης',
    payment: 'Πληρωμή',
    any: 'Οποιαδήποτε',
    authorized: 'Εξουσιοδοτημένη',
    pending: 'Εκκρεμής',
    paid: 'Πληρωμένη',
    partiallyPaid: 'Μερικώς πληρωμένη',
    refunded: 'Επιστράφηκε',
    voided: 'Ακυρωμένη',
    partiallyRefunded: 'Μερικώς επιστράφηκε',
    unpaid: 'Απλήρωτη',
    fulfillment: 'Εκπλήρωση',
    fulfilled: 'Απεσταλμένη',
    partial: 'Μερική',
    unfulfilled: 'Μη απεσταλμένη',
    loading: 'Φόρτωση παραγγελιών...',
    search: 'Αναζήτηση',
  },
  orderList: {
    noCustomer: 'Χωρίς Πελάτη',
    downloadOrder: 'Λήψη Παραγγελίας',
    deleteWarning: 'Σημαντικό! Αυτό θα διαγράψει όλα τα τιμολόγια και τις επιστροφές που δημιουργήθηκαν μετά την ημερομηνία:',
    includingInvoice: 'συμπεριλαμβανομένου του επιλεγμένου τιμολογίου #',
    pressOk: 'Πατήστε OK για να συνεχίσετε ή Ακύρωση για να ματαιώσετε.',
    cannotCreateAutopilot: 'Δεν μπορείτε να δημιουργήσετε τιμολόγια χειροκίνητα όταν η τιμολόγηση είναι σε αυτόματη λειτουργία.',
    createInvoice: 'Δημιουργία τιμολογίου για αυτή την παραγγελία',
    create: 'Δημιουργία',
    addCreditNote: 'Προσθήκη Πιστωτικού Σημειώματος',
    createStorno: 'Δημιουργία Storno Τιμολογίου',
    refund: 'Επιστροφή',
    downloadInvoice: 'Λήψη αυτού του τιμολογίου',
    download: 'Λήψη',
    default: 'Προεπιλογή',
    downloadStorno: 'Λήψη αυτού του storno/πιστωτικού σημειώματος',
    fulfillOrder: 'Εκπλήρωση Παραγγελίας',
    orderNum: 'Παραγγελία #',
    locPrefix: 'Πρόθεμα Τοποθ.',
    invoiceNum: 'Τιμολόγιο #',
    refundNum: 'Επιστροφή #',
    customerCol: 'Πελάτης',
    orderCreatedDate: 'Ημερομηνία Δημιουργίας Παραγγελίας',
    orderModifiedDate: 'Ημερομηνία Τροποποίησης Παραγγελίας',
    delivered: 'Παραδόθηκε',
    paymentStatus: 'Κατάσταση Πληρωμής',
    fulfillmentStatus: 'Κατάσταση αποστολής',
    totalOutstanding: 'Συνολικό Οφειλόμενο Ποσό',
    originalPrice: 'Αρχική Τιμή',
    noOrders: 'Το κατάστημά σας δεν έχει παραγγελίες για την επιλεγμένη κατάσταση.',
    cannotCreateNoOrders: 'Δεν μπορείτε να δημιουργήσετε τιμολόγια όταν δεν υπάρχουν παραγγελίες.',
    createOrdersFirst: 'Δημιουργήστε τουλάχιστον μία παραγγελία και δοκιμάστε ξανά.',
    createOrders: 'Δημιουργία παραγγελιών',
    loadingOrders: 'Φόρτωση...',
    paidManual: 'Πληρωμένη - Χειροκίνητα',
    paid: 'Πληρωμένη',
    refunded: 'Επιστράφηκε',
    pending: 'Εκκρεμής',
    partiallyPaid: 'Μερικώς πληρωμένη',
    partiallyRefunded: 'Μερικώς επιστράφηκε',
    fulfilled: 'Απεσταλμένη',
    unfulfilled: 'Μη απεσταλμένη',
    deliveryPending: 'Εκκρεμής',
    deliverNow: 'Παράδοση τώρα',
    deliveryPartial: 'Μερική',
    notDelivered: 'Δεν παραδόθηκε',
    deliverAgain: 'Παράδοση ξανά',
    deliveryDetails: 'Λεπτομέρειες παράδοσης',
    deliveryFailed: 'Αποτυχία παράδοσης',
    sent: 'Απεστάλη',
    failed: 'Απέτυχε',
    toLabel: 'Προς',
    folderLabel: 'Φάκελος',
    open: 'Ανοιχτή',
    invoice: 'Τιμολόγιο',
    creditNote: 'Πιστωτικό σημείωμα',
    stornoLabel: 'Ακύρωση',
    unknown: 'Άγνωστο',
    googleDrive: 'Google Drive',
    clientsTablet: 'Tablet πελατών',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-mail',
    ftpChannel: 'FTP',
    revertToDate: 'Επαναφορά σε αυτή την ημερομηνία',
    add: 'Προσθήκη',
    close: 'Κλείσιμο',
  },
  downloadDialog: {
    downloadType: 'Λήψη {type}...',
    selectTemplate: 'Επιλέξτε ένα πρότυπο από τη συλλογή για εξαγωγή παραγγελιών, τιμολογίων, storno τιμολογίων ή πιστωτικών σημειωμάτων.',
    getMoreTemplates: 'Περισσότερα Πρότυπα',
    createNewTemplate: 'Δημιουργία νέου Προτύπου',
    allCreatedBetween: 'Όλα τα δημιουργημένα {type} μεταξύ',
    selectedType: 'Επιλεγμένα {type}',
    and: 'και',
    status: 'Κατάσταση',
    any: 'Οποιαδήποτε',
    open: 'Ανοιχτή',
    closed: 'Κλειστή',
    cancelled: 'Ακυρωμένη',
    paymentStatus: 'Κατάσταση Πληρωμής',
    fulfillmentStatus: 'Κατάσταση αποστολής',
    fulfilled: 'Απεσταλμένη',
    partial: 'Μερική',
    unfulfilled: 'Μη απεσταλμένη',
    authorized: 'Εξουσιοδοτημένη',
    pending: 'Εκκρεμής',
    paid: 'Πληρωμένη',
    partiallyPaid: 'Μερικώς πληρωμένη',
    refunded: 'Επιστράφηκε',
    voided: 'Ακυρωμένη',
    partiallyRefunded: 'Μερικώς επιστράφηκε',
    unpaid: 'Απλήρωτη',
    format: 'Μορφή',
    forLocation: 'Για τοποθεσία',
    advancedOptions: 'Σύνθετες επιλογές',
    exportHSCodes: 'Εξαγωγή κωδικών HS αποθέματος (πιο αργό)',
    noteChrome: 'Σημείωση: Για βέλτιστη λήψη συνιστάται ο Chrome και η απενεργοποίηση του adblocker.',
    downloadIndividually: 'Λήψη μεμονωμένα',
    downloadGrouped: 'Λήψη ομαδοποιημένα',
  },
  templates: {
    pageTitle: 'Πρότυπα',
    pageDescription: 'Customize your invoice templates',
    title: 'Πρότυπα',
    installTranslated: 'Εγκατάσταση μεταφρασμένου προτύπου',
    installTranslatedDesc: 'Επιλέξτε μια διαφορετική γλώσσα κάνοντας κλικ σε αυτό το κουμπί.',
    createNew: 'Δημιουργία νέου προτύπου εάν χρειαστεί',
    createNewDesc: 'Κάντε κλικ σε αυτό το κουμπί για να δημιουργήσετε ένα νέο πρότυπο εάν χρειαστεί.',
    customize: 'Προσαρμογή προτύπων',
    customizeDesc: 'Κάντε κλικ στο προεπιλεγμένο πρότυπο για να το προσαρμόσετε. Μπορείτε να αλλάξετε λογότυπο, χρώματα και για πιο προχωρημένους χρήστες, τον κώδικα.',
    defaultTemplate: 'Τιμολόγιο, Storno και Πιστωτικό Σημείωμα (Προεπιλογή)',
    logo: 'Λογότυπο',
    colorPalette: 'Παλέτα Χρωμάτων',
    getColorPalettes: 'Λήψη παλετών χρωμάτων',
    paperSize: 'Μέγεθος Χαρτιού',
    format: 'Μορφή',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Προσανατολισμός',
    landscape: 'Οριζόντιος',
    portrait: 'Κατακόρυφος',
    margin: 'Περιθώριο (cm)',
    unsavedChanges: 'Μη αποθηκευμένες αλλαγές',
    discard: 'Απόρριψη',
    save: 'Αποθήκευση',
  },
  labels: {
    pageTitle: 'Ετικέτες Αποστολής',
    pageDescription: 'Create and manage shipping labels',
    title: 'Ετικέτες Αποστολής',
    glsRequiresPro: 'Οι Ετικέτες Αποστολής GLS για ΕΕU απαιτούν το πλάνο Professional.',
    upgradeDesc: 'Αναβαθμίστε σε Professional για να δημιουργείτε και να διαχειρίζεστε ετικέτες αποστολής.',
    upgradePlan: 'Αναβαθμίστε το πλάνο σας',
    eeuGls: 'EEU GLS',
    enabled: 'Ενεργοποιημένο',
    country: 'Χώρα',
    hungary: 'Ουγγαρία',
    slovakia: 'Σλοβακία',
    czech: 'Τσεχία',
    romania: 'Ρουμανία',
    slovenia: 'Σλοβενία',
    croatia: 'Κροατία',
    senderId: 'Αναγνωριστικό Αποστολέα',
    username: 'Όνομα χρήστη',
    password: 'Κωδικός πρόσβασης',
    name: 'Όνομα',
    city: 'Πόλη',
    address: 'Διεύθυνση',
    zipCode: 'Ταχυδρομικός Κώδικας',
    contactPerson: 'Υπεύθυνος Επικοινωνίας',
    phone: 'Τηλέφωνο',
    email: 'Email',
    glsServices: 'Υπηρεσίες GLS',
    expressService: 'Υπηρεσία Express',
    exchangeService: 'Υπηρεσία Ανταλλαγής',
    smsService: 'Υπηρεσία SMS',
    smsText: 'Κείμενο SMS',
    preAdviceService: 'Υπηρεσία PreAdvice',
    unsavedChanges: 'Μη αποθηκευμένες αλλαγές',
    discard: 'Απόρριψη',
    save: 'Αποθήκευση',
  },
  billing: {
    pageTitle: 'Χρεώσεις',
    pageDescription: 'Manage your subscription and billing',
    title: 'Χρεώσεις',
    subscriptionFor: 'Πλάνο συνδρομής για κατάστημα',
    currentlySubscribed: 'Αυτή τη στιγμή είστε συνδρομητής στο',
    plan: 'πλάνο',
    cancelSubscription: 'Ακύρωση Συνδρομής',
    upgradePlan: 'Αναβαθμίστε το πλάνο σας',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / μήνα',
    upgrade: 'Αναβάθμιση',
    includesAllStarter: 'Περιλαμβάνει όλες τις δυνατότητες του Starter, συν:',
    proFeature1: 'Παγκόσμια Σουίτα Συμμόρφωσης: Προθέματα βάσει τοποθεσίας και προσαρμοσμένη διαδοχική αρίθμηση',
    proFeature2: 'Έξυπνη Τοπικοποίηση: Αυτόματα μεταφρασμένα email και τοπικοποιημένα PDF συνημμένα',
    proFeature3: 'Πλήρης Κύκλος Εγγράφων B2B: Προτιμολόγια, Προσφορές B2B και Πιστωτικά Σημειώματα',
    proFeature4: 'Συγχρονισμός Λογιστικής B2B: Ακρίβεια 3 δεκαδικών ψηφίων και εμφάνιση πολλαπλών νομισμάτων',
    proFeature5: 'Αυτοματοποιημένα Αντίγραφα Ασφαλείας: Αυτόματη αντιγραφή τιμολογίων σε ασφαλή FTP ή Google Drive',
    proFeature6: 'Shopify Flow: Αυτοματοποίηση δημιουργίας, παράδοσης και storno τιμολογίων μέσω Flow triggers και actions',
    proFeature7: 'Προηγμένη Λογική AI: Χρήση του on-device AI για σύνθετους κανόνες διάταξης υπό συνθήκη',
    proFeature8: 'Εξαγωγές UBL XML & ZUGFeRD / Factur-X (Ευρωπαϊκή συμμόρφωση ηλεκτρονικής τιμολόγησης)',
    proFeature9: 'Κωδικοί EPC QR για άμεσες πληρωμές μέσω κινητού POS',
    proFeature10: 'Ετικέτες Αποστολής GLS για EEU',
    proFeature11: 'Φορολογική διατήρηση συμμόρφωσης 7 ετών',
    currentlyUsing: 'Αυτή τη στιγμή χρησιμοποιείτε το',
    free: 'δωρεάν',
    subscriptionPlan: 'πλάνο συνδρομής.',
    monthlyUsage: 'Μηνιαία Χρήση',
    monthlyGenerated: '{count} / 50 τιμολόγια αυτόν τον μήνα',
    monthlyLimitReached: 'Το μηνιαίο όριο εξαντλήθηκε. Αναβαθμίστε σε Starter για απεριόριστα τιμολόγια.',
    freePlan: 'Δωρεάν Πλάνο',
    freeToInstall: 'Δωρεάν εγκατάσταση',
    freeFeature1: 'Έως 50 τιμολόγια/παραγγελίες ανά μήνα',
    freeFeature2: 'Πρόσβαση σε όλα τα 31+ προκαθορισμένα πρότυπα',
    freeFeature3: 'Βασικό AI Copilot',
    freeFeature4: 'Τυπικές λήψεις PDF & εκτύπωση',
    freeFeature5: 'Τυπική σουίτα εγγράφων (Τιμολόγια, Δελτία Αποστολής, Αποδείξεις)',
    freeFeature6: 'Ασφαλής διατήρηση τιμολογίων 3 μηνών',
    starterPlan: 'Πλάνο Starter',
    starterPrice: '$9.99 / μήνα',
    starterPricePerInvoice: '+ 3¢ ανά δημιουργημένο τιμολόγιο',
    subscribe: 'Εγγραφή',
    starterFeature1: 'Απεριόριστα τιμολόγια & παραγγελίες',
    starterFeature2: 'Αυτοματοποιημένη παράδοση PDF μέσω email',
    starterFeature3: 'Πλήρης πρόσβαση στον υβριδικό επεξεργαστή & AI Copilot',
    starterFeature4: 'Ενσωμάτωση Shopify POS & barcode',
    starterFeature5: 'Shopify Flow: Triggers & actions για αυτοματοποίηση τιμολογίων',
    starterFeature6: 'Εξαγωγές UBL XML / PEPPOL & ZUGFeRD / Factur-X (Συμμόρφωση ηλεκτρονικής τιμολόγησης)',
    starterFeature7: 'Ασφαλής διατήρηση τιμολογίων 1 έτους',
    proTaxOverrides: 'Προσαρμοσμένες Φορολογικές Παρακάμψεις: ΦΠΑ / GST ανά προϊόν και συντελεστές ανά SKU',
    unsavedChanges: 'Μη αποθηκευμένες αλλαγές',
    discard: 'Απόρριψη',
    save: 'Αποθήκευση',
  },
  autopilot: {
    pageTitle: 'Αυτοματισμός',
    pageDescription: 'Automate invoice creation and management',
    title: 'Αυτοματισμός',
    autoCreate: 'Αυτόματη Δημιουργία Τιμολογίων',
    disabled: 'Απενεργοποιημένο (Χειροκίνητο)',
    whenCreated: 'Όταν δημιουργούνται παραγγελίες',
    whenFulfilled: 'Όταν εκπληρώνονται παραγγελίες',
    whenPaid: 'Όταν πληρώνονται παραγγελίες',
    autoCreateDesc: 'Τα τιμολόγια θα δημιουργούνται την ημερομηνία που οι παραγγελίες δημιουργούνται, εκπληρώνονται ή πληρώνονται.',
    autoStorno: 'Αυτόματο Storno Τιμολογίων',
    whenCancelled: 'Όταν οι παραγγελίες ακυρώνονται ή επιστρέφονται',
    autoStornoDesc: 'Τα storno τιμολόγια θα δημιουργούνται την ημερομηνία που οι παραγγελίες ακυρώνονται ή δημιουργούνται επιστροφές.',
    cannotAutoFree: 'Η αυτόματη δημιουργία τιμολογίων δεν είναι δυνατή με το δωρεάν πλάνο.',
    upgradePlan: 'Αναβαθμίστε το πλάνο σας',
    unsavedChanges: 'Μη αποθηκευμένες αλλαγές',
    discard: 'Απόρριψη',
    save: 'Αποθήκευση',
  },
  delivery: {
    pageTitle: 'Παράδοση',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Παράδοση',
    settings: 'Ρυθμίσεις',
    useOrderNumbers: 'Χρήση αριθμών παραγγελίας για αρχεία',
    sendIfCountry: 'Αποστολή εάν η χώρα διεύθυνσης χρέωσης είναι',
    countryCodesHint: 'Καταχωρήστε όλους τους κωδικούς χωρών διαχωρισμένους με ερωτηματικό.',
    sendForTags: 'Αποστολή για πελάτες που έχουν μία από τις αναφερόμενες ετικέτες',
    tagsHint: 'Καταχωρήστε όλες τις ετικέτες διαχωρισμένες με ερωτηματικό.',
    emailDelivery: 'Παράδοση μέσω Email',
    sendAsPdf: 'Αποστολή τιμολογίων ως συνημμένα PDF στους πελάτες',
    autoSend: 'Αυτόματη αποστολή όταν δημιουργείται τιμολόγιο',
    subject: 'Θέμα',
    body: 'Σώμα',
    xmlAttachments: 'Συνημμένα XML',
    attachUbl: 'Επισύναψη UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Επισύναψη ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Αποστολή Δοκιμαστικού Email',
    sending: 'Αποστολή...',
    customSmtp: 'Προσαρμοσμένος Διακομιστής SMTP',
    customSmtpDesc: 'Χρησιμοποιήστε τον δικό σας διακομιστή αλληλογραφίας αντί του προεπιλεγμένου',
    enableSmtp: 'Ενεργοποίηση προσαρμοσμένου SMTP',
    smtpHost: 'Κεντρικός υπολογιστής SMTP',
    port: 'Θύρα',
    useSsl: 'Χρήση SSL/TLS',
    username: 'Όνομα χρήστη',
    password: 'Κωδικός πρόσβασης',
    fromEmail: 'Email Αποστολέα',
    fromName: 'Όνομα Αποστολέα',
    shopifyLiquid: 'Πρότυπο Shopify Liquid',
    pasteInto: 'Επικολλήστε αυτό στο',
    orderConfirmation: 'πρότυπο επιβεβαίωσης παραγγελίας',
    toAddLink: 'για να προσθέσετε σύνδεσμο λήψης.',
    downloadInvoice: 'Λήψη του τιμολογίου σας',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Αποστολή αιτημάτων στο ClientsTablet όταν δημιουργούνται τιμολόγια',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Αποστολή τιμολογίων PDF ως τελωνειακά έγγραφα στο ShippyPro για χώρες εκτός ΕΕ',
    ftpBackup: 'Αντίγραφο Ασφαλείας FTP / SFTP',
    ftpDesc: 'Αυτόματη αντιγραφή τιμολογίων στον διακομιστή σας',
    enableFtp: 'Ενεργοποίηση αυτόματου αντιγράφου ασφαλείας FTP',
    host: 'Κεντρικός υπολογιστής',
    useSftp: 'Χρήση SFTP (ασφαλές)',
    destinationFolder: 'Φάκελος προορισμού',
    xmlFiles: 'Αρχεία XML',
    includeUbl: 'Συμπερίληψη UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Συμπερίληψη ZUGFeRD / Factur-X XML',
    testConnection: 'Δοκιμή Σύνδεσης',
    testing: 'Δοκιμή...',
    pro: 'PRO',
    upgradeFtp: 'Αναβαθμίστε σε Professional για αυτόματη αντιγραφή τιμολογίων στον διακομιστή FTP/SFTP σας.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Αυτόματος συγχρονισμός τιμολογίων στο Drive σας',
    connected: 'Συνδεδεμένο',
    disconnect: 'Αποσύνδεση',
    notWorking: 'Δεν λειτουργεί; Μεταβείτε στις',
    googlePermissions: 'Δικαιώματα Google',
    removeThenReconnect: 'αφαιρέστε το Invoice Browse και μετά επανασυνδεθείτε.',
    connectGoogleDrive: 'Σύνδεση Google Drive',
    upgradeGoogleDrive: 'Αναβαθμίστε σε Professional για αυτόματο συγχρονισμό τιμολογίων στο Google Drive.',
    unsavedChanges: 'Μη αποθηκευμένες αλλαγές',
    discard: 'Απόρριψη',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Αποθήκευση',
  },
  bookkeeping: {
    pageTitle: 'Ρυθμίσεις',
    pageDescription: 'Configure your invoice settings',
    title: 'Ρυθμίσεις',
    owner: 'Ιδιοκτήτης',
    email: 'Email',
    phone: 'Τηλέφωνο',
    keepDifferentNumbering: 'Διατήρηση διαφορετικής αρίθμησης τιμολογίων για κάθε τοποθεσία παραγγελίας',
    keepDifferentNumberingDisabled: 'Η διατήρηση διαφορετικής αρίθμησης τιμολογίων για κάθε τοποθεσία παραγγελίας δεν είναι ενεργοποιημένη επιλογή με το πλάνο σας.',
    locationEmailDesc: 'Αυτό σας επιτρέπει να στέλνετε email και τιμολόγια μεταφρασμένα βάσει της τοποθεσίας παραγγελίας: τοποθεσία αποθέματος, διεύθυνση αποστολής ή χρέωσης',
    upgradePlan: 'Αναβαθμίστε το πλάνο σας',
    matchingCriteria: 'Κριτήρια Αντιστοίχισης',
    locationId: 'Αναγνωριστικό Τοποθεσίας',
    shippingCountryCode: 'Κωδικός Χώρας Διεύθυνσης Αποστολής',
    billingCountryCode: 'Κωδικός Χώρας Διεύθυνσης Χρέωσης',
    matchLocationDesc: 'Αντιστοίχιση τοποθεσίας βάσει αναγνωριστικού τοποθεσίας παραγγελίας, κωδικού χώρας αποστολής ή χρέωσης.',
    companyInfo: 'Πληροφορίες Εταιρείας',
    name: 'Όνομα',
    website: 'Ιστοσελίδα',
    registrationNumber: 'Αριθμός Μητρώου',
    taxId: 'ΑΦΜ',
    addressSection: 'Διεύθυνση',
    streetName: 'Όνομα Οδού',
    streetNumber: 'Αριθμός Οδού',
    zip: 'Τ.Κ.',
    city: 'Πόλη',
    region: 'Περιφέρεια',
    country: 'Χώρα',
    bankingInfo: 'Τραπεζικά Στοιχεία',
    bankName: 'Όνομα Τράπεζας',
    swift: 'Swift',
    currency: 'Νόμισμα',
    iban: 'IBAN',
    invoicing: 'Τιμολόγηση',
    decimalPlaces: 'Δεκαδικά Ψηφία',
    invoicesPrefix: 'Πρόθεμα Τιμολογίων',
    currentInvoiceNumber: 'Τρέχων Αριθμός Τιμολογίου',
    creditNotesPrefix: 'Πρόθεμα Πιστωτικών Σημειωμάτων',
    currentCreditNoteNumber: 'Τρέχων Αριθμός Πιστωτικού Σημειώματος',
    lastInvoiceDate: 'Ημερομηνία Τελευταίου Τιμολογίου',
    noInvoicesYet: 'Δεν έχουν δημιουργηθεί τιμολόγια ακόμα.',
    confirmReverting: 'Επιβεβαίωση Επαναφοράς Συστήματος',
    allInvoicesAfter: 'Όλα τα τιμολόγια και τα storno τους που εκδόθηκαν μετά τις',
    willBeRemoved: 'θα αφαιρεθούν. Συνέχεια με την επαναφορά του συστήματος;',
    cancel: 'Ακύρωση',
    revert: 'Επαναφορά',
    revertDesc: 'Η επαναφορά του συστήματος θα διαγράψει όλα τα τιμολόγια που δημιουργήθηκαν μετά την επιλεγμένη ημερομηνία.',
    revertToDate: 'Επαναφορά σε αυτή την ημερομηνία',
    reverting: 'Επαναφορά συστήματος, παρακαλώ περιμένετε...',
    useOrderNumbering: 'Χρήση αρίθμησης παραγγελιών',
    showVat: 'Εμφάνιση ΦΠΑ στα τιμολόγια',
    overrideTaxes: 'Παράκαμψη Φόρων',
    pricesIncludeTax: 'Οι τιμές περιλαμβάνουν φόρο',
    productsTaxRate: 'Φορολογικός Συντελεστής Προϊόντων',
    shippingTaxRate: 'Φορολογικός Συντελεστής Αποστολής',
    skusSeparated: 'SKU διαχωρισμένα με ερωτηματικό',
    skusTaxRate: 'Φορολογικός Συντελεστής SKU',
    useOrderDates: 'Χρήση ημερομηνιών δημιουργίας παραγγελίας για τιμολόγια',
    convertCurrency: 'Μετατροπή τιμών στο νόμισμα πληρωμής του πελάτη',
    unsavedChanges: 'Μη αποθηκευμένες αλλαγές',
    discard: 'Απόρριψη',
    save: 'Αποθήκευση',
  },
  drafts: {
    pageTitle: 'Προσχέδια',
    pageDescription: 'Manage your draft orders',
    title: 'Προσχέδια',
    download: 'Λήψη',
    newDraft: 'Νέο Προσχέδιο',
    exporting: 'Εξαγωγή {status}%...',
    accessNotGranted: 'Δεν δόθηκε πρόσβαση στα Προσχέδια Παραγγελιών. Παρακαλώ',
    reLogin: 'συνδεθείτε ξανά',
    toGrantPermissions: 'για να παραχωρήσετε τα απαιτούμενα δικαιώματα "Προσχέδια Παραγγελιών".',
    pushFailed: 'Η αποστολή στο Shopify απέτυχε:',
    exportError: 'Σφάλμα εξαγωγής:',
    confirmDelete: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το προσχέδιο;',
    incompleteCustomer: 'Τα στοιχεία πελάτη είναι ελλιπή:',
    pushWithoutCustomer: 'Το προσχέδιο θα σταλεί στο Shopify χωρίς στοιχεία πελάτη. Συνέχεια;',
    customerNotInShopify: 'Αυτός ο πελάτης δεν υπάρχει ακόμα στο Shopify.',
    warnings: 'Προειδοποιήσεις:',
    createCustomerAndPush: 'Δημιουργία του πελάτη στο Shopify και αποστολή του προσχεδίου παραγγελίας;',
    downloadTitle: 'Λήψη προσχεδίων',
    cancel: 'Ακύρωση',
  },
  draftEdit: {
    number: "Αριθμός",
    prefix: "Πρόθεμα",

    newDraft: 'Νέο Προσχέδιο',
    editDraft: 'Επεξεργασία Προσχεδίου',
    viewInShopify: 'Προβολή στο Shopify',
    back: 'Πίσω',
    createDraft: 'Δημιουργία Προσχεδίου',
    saveChanges: 'Αποθήκευση Αλλαγών',
    documentType: 'Τύπος Εγγράφου',
    draftOrder: 'Προσχέδιο Παραγγελίας',
    quote: 'Προσφορά',
    proforma: 'Προτιμολόγιο',
    manualInvoice: 'Χειροκίνητο Τιμολόγιο',
    currency: 'Νόμισμα',
    expiryDate: 'Ημερομηνία Λήξης',
    status: 'Κατάσταση',
    draft: 'Προσχέδιο',
    sent: 'Απεσταλμένο',
    accepted: 'Αποδεκτό',
    customer: 'Πελάτης',
    firstName: 'Όνομα',
    lastName: 'Επώνυμο',
    email: 'Email',
    phone: 'Τηλέφωνο',
    company: 'Εταιρεία',
    taxId: 'ΑΦΜ',
    billingAddress: 'Διεύθυνση Χρέωσης',
    address: 'Διεύθυνση',
    aptSuite: 'Διαμέρισμα',
    city: 'Πόλη',
    province: 'Επαρχία',
    countryField: 'Χώρα',
    zip: 'Τ.Κ.',
    shippingAddress: 'Διεύθυνση Αποστολής',
    sameAsBilling: 'Ίδια με τη χρέωση',
    lineItems: 'Στοιχεία Γραμμής',
    shipping: 'Αποστολή',
    shippingTitle: 'Τίτλος',
    shippingPlaceholder: 'π.χ. Τυπική Αποστολή',
    price: 'Τιμή',
    note: 'Σημείωση',
    notePlaceholder: 'Εσωτερική σημείωση ή μήνυμα προς τον πελάτη...',
    summary: 'Σύνοψη',
    subtotal: 'Μερικό σύνολο',
    discounts: 'Εκπτώσεις',
    tax: 'Φόρος',
    total: 'Σύνολο',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Εισαγάγετε τη διεύθυνση του καταστήματός σας',
    loginWith: 'Σύνδεση με',
    createAccount: 'Δημιουργία νέου λογαριασμού',
    placeholder: 'το-κατάστημά-σας',
    shopRequired: 'Το όνομα καταστήματος είναι υποχρεωτικό',
    login: 'Σύνδεση',
    shopify: 'Shopify',
    terms: 'Όροι & Προϋποθέσεις',
    privacy: 'Πολιτική Απορρήτου',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Σας αρέσει το Invoice Browse;',
    description: 'Δημιουργήσατε τα πρώτα σας τιμολόγια! Αν βρίσκετε χρήσιμη την εφαρμογή, μια γρήγορη κριτική στο Shopify App Store μας βοηθά πολύ.',
    reward: 'Ως ευχαριστώ, θα μηδενίσουμε τον μετρητή μηνιαίας χρήσης σας',
    leaveReview: 'Αφήστε μια Κριτική',
    maybeLater: 'Ίσως αργότερα',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Καλώς ήρθατε στο Invoice Browse',
    welcomeContent: 'Επιτρέψτε μου να σας δείξω πώς μπορείτε να το χρησιμοποιήσετε.',
    dashboardTitle: 'Πίνακας Ελέγχου',
    dashboardContent: 'Η οθόνη που βλέπετε είναι ο κύριος πίνακας ελέγχου. Εδώ μπορείτε να βρείτε όλες τις παραγγελίες και να τις εξάγετε σε διαφορετικούς τύπους εγγράφων όπως: τιμολόγια, δελτία αποστολής και άλλα.',
    automationTitle: 'Κάντε τη ζωή σας ευκολότερη',
    automationContent: 'Ενεργοποιήστε τον αυτοματισμό για να δημιουργούνται τιμολόγια όποτε πληρώνονται ή επιστρέφονται παραγγελίες.',
    templatesTitle: 'Προσαρμογή προτύπων',
    templatesContent: 'Εισέλθετε εδώ για να μεταφράσετε το πρότυπό σας, να το προσαρμόσετε ή να δημιουργήσετε ένα νέο.',
    deliveryTitle: 'Παράδοση',
    deliveryContent: 'Ρυθμίστε την εφαρμογή μας να αντιγράφει αυτόματα τα δημιουργημένα έγγραφα σε FTP, Google Drive ή ως συνημμένα σε email.',
    settingsTitle: 'Ρυθμίσεις',
    settingsContent1: 'Προσαρμόστε τηλέφωνο εταιρείας, email και άλλα πεδία που χρησιμοποιούνται στα έγγραφα.',
    settingsContent2: 'Αλλάξτε τον αρχικό αριθμό εγγράφων ή διαγράψτε έγγραφα που δημιουργήθηκαν μετά από μια ημερομηνία.',
    settingsContent3: 'Παράκαμψη συντελεστών ΦΠΑ για αποστολή και προϊόντα',
    settingsContent4: 'Αλλαγή δεκαδικών ψηφίων για αριθμούς',
    reviewTitle: 'Γράψτε μια κριτική',
    reviewContent: 'Υποστηρίξτε την ομάδα μας γράφοντάς μας μια καλή κριτική!',
    tourTitle: 'Περιήγηση καλωσορίσματος',
    tourContent: 'Μπορείτε να ανοίξετε ξανά αυτή την περιήγηση από εδώ.',
    createDocTitle: 'Δημιουργήστε το πρώτο σας έγγραφο',
    createDocContent: 'Κάντε κλικ στο κουμπί Δημιουργία για να δημιουργήσετε το πρώτο σας έγγραφο.',
    docNumberTitle: 'Αριθμός εγγράφου',
    docNumberContent: 'Στο πρώτο έγγραφο εκχωρήθηκε ο αριθμός 1. Αν θέλετε να ξεκινήσετε με άλλον αριθμό μπορείτε να τον αλλάξετε από τις Ρυθμίσεις.',
    downloadDocTitle: 'Λήψη εγγράφου',
    downloadDocContent: 'Κάντε κλικ στο αναπτυσσόμενο μενού Λήψη και επιλέξτε ένα πρότυπο εγγράφου για να εξάγετε την παραγγελία σας ως PDF.',
  },
  common: {
    save: 'Αποθήκευση',
    cancel: 'Ακύρωση',
    close: 'Κλείσιμο',
    discard: 'Απόρριψη',
    delete: 'Διαγραφή',
    edit: 'Επεξεργασία',
    create: 'Δημιουργία',
    loading: 'Φόρτωση...',
    unsavedChanges: 'Μη αποθηκευμένες αλλαγές',
    upgradePlan: 'Αναβαθμίστε το πλάνο σας',
  },
  languageSelector: {
    label: 'Γλώσσα',
    auto: 'Αυτόματη ανίχνευση',
  },
  draftList: {
    draftNum: 'Προσχέδιο #',
    shopifyId: 'Shopify ID',
    type: 'Τύπος',
    customer: 'Πελάτης',
    total: 'Σύνολο',
    status: 'Κατάσταση',
    delivered: 'Παραδόθηκε',
    date: 'Ημερομηνία',
    actions: 'Ενέργειες',
    noCustomer: 'Χωρίς πελάτη',
    noDrafts: 'Δεν βρέθηκαν προσχέδια ή προσφορές.',
    loading: 'Φόρτωση...',
    download: 'Λήψη',
    default: 'Προεπιλογή',
    pending: 'Εκκρεμεί',
    deliverNow: 'Παράδοση τώρα',
    deliveryDetails: 'Λεπτομέρειες παράδοσης',
    sent: 'Στάλθηκε',
    failed: 'Απέτυχε',
    deliverAgain: 'Παράδοση ξανά',
    partial: 'Μερική',
    notDelivered: 'Δεν παραδόθηκε',
    deliveryFailed: 'Η παράδοση απέτυχε',
    unknown: 'Άγνωστο',
    edit: 'Επεξεργασία',
    send: 'Αποστολή',
    pushToShopify: 'Αποστολή στο Shopify',
    complete: 'Ολοκλήρωση',
    duplicate: 'Αντιγραφή',
    delete: 'Διαγραφή',
    quote: 'Προσφορά',
    proforma: 'Proforma',
    draftOrder: 'Προσχέδιο παραγγελίας',
    manualInvoice: 'Χειροκίνητο τιμολόγιο',
  },
  draftSearch: {
    createdBtw: 'Δημ. μεταξύ',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Πελάτης',
    status: 'Κατάσταση',
    type: 'Τύπος',
    delivery: 'Παράδοση',
    any: 'Όλα',
    draft: 'Προσχέδιο',
    sent: 'Στάλθηκε',
    accepted: 'Αποδεκτό',
    expired: 'Έληξε',
    converted: 'Μετατράπηκε',
    cancelled: 'Ακυρώθηκε',
    quote: 'Προσφορά',
    proforma: 'Proforma',
    draftOrder: 'Προσχέδιο παραγγελίας',
    manualInvoice: 'Χειροκίνητο τιμολόγιο',
    delivered: 'Παραδόθηκε',
    notDelivered: 'Δεν παραδόθηκε',
    pending: 'Εκκρεμεί',
    search: 'Αναζήτηση',
  },
  draftDownload: {
    title: 'Λήψη Προσχέδιο #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Κατάσταση',
    documentType: 'Τύπος',
    any: 'Όλα',
    draft: 'Προσχέδιο',
    sent: 'Στάλθηκε',
    accepted: 'Αποδεκτό',
    expired: 'Έληξε',
    converted: 'Μετατράπηκε',
    cancelled: 'Ακυρώθηκε',
    quote: 'Προσφορά',
    proforma: 'Proforma',
    draftOrder: 'Προσχέδιο παραγγελίας',
    manualInvoice: 'Χειροκίνητο τιμολόγιο',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Εγκατάσταση νέου προτύπου',
    tabStyle: 'Στυλ',
    tabContent: 'Περιεχόμενο',
    tabTranslations: 'Μεταφράσεις',
    tabSettings: 'Ρυθμίσεις',
    tabCode: 'Κώδικας',
    tabCopilot: 'AI Copilot',
    logo: 'Λογότυπο',
    colorPalette: 'Παλέτα χρωμάτων',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/el.js